export default __webpack_public_path__ + "static/media/seo.9dd94f79.png";